import contentRequest from '~/src/api/requests/contentRequest';

/**
 * Получение документов из api-content
 * @param {String} cityDomain
 * @returns {Promise<any|undefined>}
 */

export async function getDocumentCategories(cityDomain) {
    const date = new Date();
    let month = date.getMonth() + 1;
    month = month >= 10 ? month.toString() : `0${month}`;
    const dateString = `${date.getFullYear()}-${month}-${date.getDate()}`;
    return contentRequest.get(
        cityDomain + '/v1/document-categories?expand=documents&sort=title&active_to=' + dateString
    ).then(response => {
        return response.data.items;
    }).catch(e => console.error('contentRequest for documents error:', e));
}
